// 测试环境
//const webSite = 'http://192.168.0.159:9205/cdutUnitMgt' 
// const webSite = 'http://192.168.0.199:9205/xhuUnitMgt' 
// const mobileUrl = 'http://120.27.150.141:8013'

//正式地址
const webSite = 'https://cdutzkbm.028zk01.net/cdutUnitMgt' 
const mobileUrl = 'https://cdutzkbmh5.028zk01.net'
export default {
  webSite,
  mobileUrl
}
